<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <modal-sale-edit :reloadSale.sync="reload" :objToModal="sendObj"/>

    <section>
      <page-header :headerName="'Relatório de Vendas'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="name">Id da empresa</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" id="name" name="name">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Mês</label>
                      <select v-model="dataSearch.month">
                        <option value="">Selecione</option>
                        <option value="1">Janeiro</option>
                        <option value="2">Fevereiro</option>
                        <option value="3">Março</option>
                        <option value="4">Abril</option>
                        <option value="5">Maio</option>
                        <option value="6">Junho</option>
                        <option value="7">Julho</option>
                        <option value="8">Agosto</option>
                        <option value="9">Setembro</option>
                        <option value="10">Outubro</option>
                        <option value="11">Novembro</option>
                        <option value="12">Dezembro</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Mês de expiração</label>
                      <select v-model="dataSearch.expirationDateMonth">
                        <option value="">Selecione</option>
                        <option value="1">Janeiro</option>
                        <option value="2">Fevereiro</option>
                        <option value="3">Março</option>
                        <option value="4">Abril</option>
                        <option value="5">Maio</option>
                        <option value="6">Junho</option>
                        <option value="7">Julho</option>
                        <option value="8">Agosto</option>
                        <option value="9">Setembro</option>
                        <option value="10">Outubro</option>
                        <option value="11">Novembro</option>
                        <option value="12">Dezembro</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Duração</label>
                      <select v-model="dataSearch.duration" id="duration" name="duration" required>
                        <option value="">Selecione</option>
                        <option value="Mensal">Mensal</option>
                        <option value="Semestral">Semestral</option>
                        <option value="Bimestral">Bimestral</option>
                        <option value="Trimestral">Trimestral</option>
                        <option value="Anual">Anual</option>
                        <option value="BiAnual">BiAnual</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataList !== '' && !dataList.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum resultado encontrado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição, tente novamente ou contate os DEVS.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total ({{ dataList.length }})</span>
                  </div>

                  <a v-on:click="downloadActualListExcel()" class="btn-all-excel right" title="Imprimir">
                    <span>Gerar Excel</span>
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                  </a>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <p class="price-value">Valor total: <span>R$ {{ totalValue }}</span></p>
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> DURAÇÃO</th>
                        <th> QTD FUNCIONÁRIOS</th>
                        <th> MRR</th>
                        <th> MÊS</th>
                        <th> OBS</th>
                        <th> DATA INÍCIO</th>
                        <th> DATA FIM</th>
                        <th> POR</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(c, index) in dataList">
                        <td><a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.contentContext"
                               target="_blank" class="link">{{ c.companyName }}</a></td>
                        <td>{{ c.duration }}</td>
                        <td>{{ c.totalEmployee }}</td>
                        <td>R$ {{ c.mrrValue }}</td>
                        <td>
                          <span v-if="c.month === 1">Janeiro</span>
                          <span v-if="c.month === 2">Fevereiro</span>
                          <span v-if="c.month === 3">Março</span>
                          <span v-if="c.month === 4">Abril</span>
                          <span v-if="c.month === 5">Maio</span>
                          <span v-if="c.month === 6">Junho</span>
                          <span v-if="c.month === 7">Julho</span>
                          <span v-if="c.month === 8">Agosto</span>
                          <span v-if="c.month === 9">Setembro</span>
                          <span v-if="c.month === 10">Outubro</span>
                          <span v-if="c.month === 11">Novembro</span>
                          <span v-if="c.month === 12">Dezembro</span>
                        </td>
                        <td>{{ c.notes }}</td>
                        <td>{{ c.startAt | formatDate }}</td>
                        <td>{{ c.endAt | formatDate }}</td>
                        <td>{{ c.soldBy }}</td>
                        <td>
                          <a v-on:click="changeSale(c)" title="Editar" class="btn-to-edit">
                            <i class="fa fa-pencil" aria-hidden="true"></i> Editar
                          </a>
                          <a v-on:click="checkRemoveSale(c)" title="Ativar/Desativar" class="btn-to-delete">
                            <i class="fa fa-ban" aria-hidden="true"></i> Excluir
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import modalSaleEdit from "../../modals/modalSaleEdit.vue";

import {
  REPORT_SALE,
  REPORT_SALE_S,
  DELETE_SALE,
  DESACTIVE_ACTIVE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";
import swal from "sweetalert";

export default {
  name: "report-sale",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
    modalSaleEdit
  },
  data() {
    return {
      totalValue: 0,
      reload: null,
      sendObj: {},
      failRequest: false,
      loadingChurn: false,
      loadingList: false,
      dataList: [],
      dataSearch: {
        month: '',
        expirationDateMonth: '',
        companyId: '',
        duration: ''
      }
    }
  },
  methods: {
    checkRemoveSale(data) {
      let msg = "Você tem certeza que deseja excluir a venda da empresa: " + data.companyName + " no valor de " + data.mrrValue + ", vendido por " + data.soldBy;
      swal({
        title: "Aviso",
        text: msg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((valueInput) => {
          if (valueInput) {
            this.loadingList = true;

            let url = DELETE_SALE + "?id=" + data.id;
            UTIL_SERVICE.console("SEND:", url);
            REQUEST_SERVICE.get(url).then((response) => {
              UTIL_SERVICE.console("RESULT DELETE_SALE:", response.data);

              ALERT_SERVICE.swal("Aviso", "Venda excluída com sucesso.", "success");
              this.getList();
            }).catch((reason) => {
              this.loadingList = false;

              ALERT_SERVICE.showMsgError(reason.response.data.erros);
            });
          }
        });
    },
    changeSale(dataCompany) {
      REQUEST_SERVICE.get(REPORT_SALE_S + '/' + dataCompany.id).then((response) => {
        UTIL_SERVICE.console("RESULT REPORT_SALE_S:", response.data);

        this.sendObj = {
          company: response.data,
          random: Math.floor(Math.random() * 500)
        };

        $("#modalSaleEdit").modal();
      }).catch((reason) => {
      });
    },
    downloadActualListExcel() {
      let bodyValue = [];
      this.dataList.map((value, index) => {
        bodyValue.push([value.companyName, value.duration, value.totalEmployee, value.mrrValue, value.month, value.notes, moment(String(value.startAt)).format('DD/MM/YYYY'), moment(String(value.endAt)).format('DD/MM/YYYY'), value.soldBy]);

        if (index + 1 === this.dataList.length) {
          let headValue = ["EMPRESA", "DURAÇÃO", "QTD FUNCIONÁRIOS", "VALOR", "MÊS", "OBS", "DATA INÍCIO", "DATA FIM ", "POR"];

          window.downloadListExcel(headValue, bodyValue, "Relatório de Venda");
        }
      });
    },
    getList() {
      this.dataList = [];
      this.loadingList = true;
      this.failRequest = false;
      let url = REPORT_SALE;
      url += "?t=kkkk";

      if (this.dataSearch.month)
        url += "&month=" + parseInt(this.dataSearch.month);
      if (this.dataSearch.expirationDateMonth)
        url += "&expirationDateMonth=" + parseInt(this.dataSearch.expirationDateMonth);
      if (this.dataSearch.companyId)
        url += "&companyId=" + this.dataSearch.companyId;
      if (this.dataSearch.duration)
        url += "&duration=" + this.dataSearch.duration;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT REPORT_SALE:", response.data);

        this.dataList = response.data;

        this.totalValue = 0;
        this.dataList.map((value, index) => {
          this.totalValue += value.mrrValue;
        });
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  },
  watch: {
    reload: function (val) {
      this.getList();
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<style lang="scss">
.price-value {
  display: block;
  margin-bottom: 20px;
  font-weight: 600;
  text-transform: capitalize;
  color: #444D58;
  font-size: 16px;
  margin-left: 6px;
  margin-top: 0;

  span {
    color: #00A651;
  }
}

.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00A651;
  color: #FFF;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #FFF;
    background-color: #008D45;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/reports/reportSale.vue